import Filter from '@components/Filter';
import styled from '@emotion/styled';
import { GetDownloadableCouponsParams } from '@models/coupon';
import { useTranslation } from 'react-i18next';

interface Props {
    sorter: GetDownloadableCouponsParams['sorter']
    setSorter: (v: GetDownloadableCouponsParams['sorter']) =>void;
}

function CouponFilter({ sorter, setSorter }:Props) {
    const { t } = useTranslation('coupon');
    return (
        <Wrapper>
            <Filter title={t('filter.title')} sort={sorter}
                setSort={setSorter}
                sortItems={[
                    { value: 'CreatedAtAsc', label: t('filter.createdAtAsc') },
                    { value: 'EndAtAsc', label: t('filter.endAtAsc') },
                ]} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 12px 16px;
`;

export default CouponFilter;
